module.exports = __webpack_public_path__ + "img/home_poster01.7b63fc97.png";